import * as React from 'react';
import { Checkmark, FontAwesomeIcon } from '@magoosh/lib/icons';
import { StudyItemData } from '@magoosh/organisms/study_items/types';
import { LinkButton } from '@magoosh/lib/button';
import style from '../style.module.scss';
import cx from 'classnames';

interface ModuleItemProps {
  item: StudyItemData;
  onClick: (item: StudyItemData, clickCompletionCallback: () => void) => void;
  onCompletedToggle: any;
}

interface ModuleItemState {
  submitting: boolean;
}

export default class ModuleItem extends React.Component<ModuleItemProps, ModuleItemState> {
  state = {
    submitting: false
  };

  render() {
    const { completed, estimatedTimeMinutes, id, name, type, url } = this.props.item;
    return (
      <div className={cx(style.studyItem)} onClick={this.handleItemClick}>
        <div className={style.iconCell}>{this.renderIcon()}</div>
        <div className={style.itemName}>
          <LinkButton
            className={cx(style.itemLink, completed ? style.completedItem : '')}
            submitting={this.state.submitting}>
            {name}
          </LinkButton>
        </div>
        <div className={style.timeCell}>
          <span>{estimatedTimeMinutes} minutes</span>
        </div>
        <div className={style.checkmark}>
          <a onClick={this.handleCompletedToggle}>
            <Checkmark completed={completed} />
          </a>
        </div>
      </div>
    );
  }

  renderIcon = () => {
    if (this.props.item.type == 'Lesson') {
      return <FontAwesomeIcon icon={'play-circle-o'} />;
    }
    return <FontAwesomeIcon icon={'graduation-cap'} />;
  };

  handleItemClick = (e) => {
    this.setState({ submitting: true });
    this.props.onClick(this.props.item, this.itemClickCompletion.bind(this));
  };

  itemClickCompletion = () => {
    this.setState({ submitting: false });
  };

  handleCompletedToggle = (event) => {
    event.stopPropagation();
    this.props.onCompletedToggle(this.props.item, !this.props.item.completed);
  };
}
